/* Tab-scoped design recovery only. Never persist customer/contact form data. */
function createPapasDraftStore(catalog, getStorage) {
  const key = 'papas-denim-design-v1';
  function clean(value) {
    if (!value || value.version !== 1 || !Object.prototype.hasOwnProperty.call(catalog, value.garment)) return null;
    const designs = {};
    for (const garment of Object.keys(catalog)) {
      const allowed = new Set(catalog[garment].options.map(option => option.id));
      const ids = Array.isArray(value.designs?.[garment]) ? value.designs[garment] : [];
      designs[garment] = [...new Set(ids.filter(id => allowed.has(id)))];
      if (designs[garment].includes('sherpa-sleeves')) designs[garment] = designs[garment].filter(id => id !== 'sherpa-cuffs');
    }
    return {version:1, garment:value.garment, view:value.garment === 'shirt' && value.view === 'back' ? 'back' : 'front', designs};
  }
  return {
    read() {
      try { return clean(JSON.parse(getStorage().getItem(key))); }
      catch { return null; }
    },
    write(value) {
      try { const draft = clean(value); if (draft) getStorage().setItem(key, JSON.stringify(draft)); }
      catch { /* Storage may be blocked. Customization still works without it. */ }
    }
  };
}
